<template>
    <div class="row">
        <div class="col d-flex cta-wrapper">
            <router-link class="button button--solid" :to="{name:'enquire'}" @click.native="ctaClick('Enquire')">Enquire about this vehicle</router-link>
            <router-link class="button button--ghost-white" :to="{name:'home'}" @click.native="ctaClick('Back-To-List')">Back to vehicle list</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CtaBlock",
        methods: {
            ctaClick: function(value) {
                this.$tracking.logCTA('SME-Price-List:CTA:'+value);
            }
        }
    }
</script>

<style scoped lang="stylus">
</style>